import { BaseModel } from './base-model';
import { indexOf } from 'lodash-es';
import { Dob } from './contracts/contracts';

export class User extends BaseModel {
    id: number;
    firstName: string;
    lastName: string;
    password: string;
    username: string; // refers to the email
    teacherUsername: string;
    confirmPassword: string;
    email: string;
    roles: string[] = [];
    verifiedEmail: boolean;
    impersonatedEmail: string;
    lastLoginDate: number;
    createDate: number;
    languageId: number;
    genderId: number;
    about: string;
    originCountry: any;
    residenceCountry: any;
    yearOfBirth: number;
    dob: Dob;
    proficiencies: Array<any>;
    languages: Array<number>;
    profileImageDownloadUrl: string;

    constructor(data: any = {}) {
        super(data);

        this.dob = data?.dob ? data.dob : null;
        this.roles = data.roles || [];
        this.email = data.email || data.username;
        this.proficiencies = data.proficiencies || [];
        this.languages = data.languages || [];
        this.originCountry = data?.originCountry;
        this.residenceCountry = data?.residenceCountry;
    }

    public hasRole(role: string): boolean {
        return indexOf(this.roles, role) > -1;
    }
}
